import { useRef, useEffect } from "react";

export function SignaturePad({ onChange, testid }) {
  const ref = useRef(null);
  const drawing = useRef(false);
  const dirty = useRef(false);

  useEffect(() => {
    const c = ref.current;
    c.width = c.offsetWidth * 2;
    c.height = 280;
    const ctx = c.getContext("2d");
    ctx.scale(2, 2);
    ctx.lineWidth = 2;
    ctx.lineCap = "round";
    ctx.strokeStyle = "#111";
  }, []);

  const pos = (e) => { const r = ref.current.getBoundingClientRect(); return [e.clientX - r.left, e.clientY - r.top]; };
  const down = (e) => { drawing.current = true; const ctx = ref.current.getContext("2d"); ctx.beginPath(); ctx.moveTo(...pos(e)); };
  const move = (e) => { if (!drawing.current) return; const ctx = ref.current.getContext("2d"); ctx.lineTo(...pos(e)); ctx.stroke(); dirty.current = true; };
  const up = () => { if (!drawing.current) return; drawing.current = false; if (dirty.current) onChange(ref.current.toDataURL("image/png")); };
  const clear = () => { const c = ref.current; c.getContext("2d").clearRect(0, 0, c.width, c.height); dirty.current = false; onChange(null); };

  return (
    <div>
      <canvas ref={ref} data-testid={testid} onPointerDown={down} onPointerMove={move} onPointerUp={up} onPointerLeave={up}
        className="w-full h-[140px] bg-white border border-dashed border-stone-300 rounded-lg touch-none cursor-crosshair" />
      <div className="flex justify-between mt-1 text-xs text-stone-500">
        <span>Sign above with your finger or mouse</span>
        <button type="button" onClick={clear} data-testid={`${testid}-clear`} className="underline">Clear</button>
      </div>
    </div>
  );
}
